module.exports = __webpack_public_path__ + "img/s1v3t1.1d18a209.jpg";